import _createForOfIteratorHelper from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.includes.js";
import { computed, defineComponent, nextTick, ref, watch } from "vue"; // modules

import { PCTypes, RetailOptionType } from "@/types/db/product-category";
import { fetchAllPCsTimeslotsByDate, getTimeslotsByDate } from "@/utils/helpers/timeslots";
import { getProductCategoriesByTicketsGroup, getProductCategoryById, getProductCategoryByPrice } from "@/utils/helpers/product-category";
import Card from "@/components/Card.vue";
import { Virtual, FreeMode, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue"; // Import Swiper styles

import "swiper/swiper.scss"; // core Swiper

import "swiper/modules/navigation/navigation.scss"; // Navigation module

import "swiper/modules/pagination/pagination.scss"; // Pagination module

import { getLanguage } from "@/utils/helpers/lang";
import dayjs from "dayjs";
import POSConfigModule from "@/store/modules/pos-config";
import _cloneDeep from "lodash/cloneDeep";
import { Calendar } from "@element-plus/icons-vue";
import { cloneDeep, sortedIndex } from "lodash";
import { getGroupDayJsTimeFormat } from "@/utils/helpers/dates";
import { selectedConfig } from "@/utils/vue-helpers/pos-config"; // import 'dayjs/locale/fr' // import the French locale for dayjs

import { ElConfigProvider } from "element-plus";
import fr from "element-plus/lib/locale/lang/fr";
import de from "element-plus/lib/locale/lang/de";
import en from "element-plus/lib/locale/lang/en";
import it from "element-plus/lib/locale/lang/it";
import AppModule from "@/store/modules/app";
import infoIcon from "@/assets/images/svg/info-circle.svg";
import NotificationService from "@/services/notification.service";
import { useI18n } from "vue-i18n";
import todayIcon from "@/assets/images/svg/calendar-today.svg";
import todayIconBlack from "@/assets/images/svg/calendar-today-black.svg";
import { ModalStatus } from "@/constants/modal";
import ModalModule from "@/store/modules/modal";
import UserModule from "@/store/modules/user";
import { recordOperationDuration } from "@/utils/vue-helpers/common";
import { es } from "element-plus/es/locale";
import CommonModule from "@/store/modules/common";
import { LogService } from "@/services/logging"; // Cache for calendar dates

var ticketGroupDates = {}; // Should have added swiper as ref in the component but couldn't access it in methods after doing that.

var swiper = null;
export default defineComponent({
  name: "CalendarCards",
  components: {
    Card: Card,
    Swiper: Swiper,
    SwiperSlide: SwiperSlide,
    ElConfigProvider: ElConfigProvider
  },
  props: {
    ticketGroupId: {
      type: Number,
      required: true
    }
  },
  setup: function setup() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var loading, selectedDate, allDates, pulledDates, datepicker, isFetchingFutureDate, todayDate, calendarCardsContainer, locale, _useI18n, t, setSwiperRef, openCalendar, isDateDisabled, cards, didScroll, handleScroll, handleTouchStart, scrollToGroupingHour, scrollToTimeSlot, _scrollToTimeSlot, scrollToFirstAvailableEvent, _scrollToFirstAvailableEvent;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _scrollToFirstAvailableEvent = function _scrollToFirstAvailab2() {
                _scrollToFirstAvailableEvent = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(product) {
                  var targetDate, targetEventTime, _targetEventTime, firstGroupingHour;

                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (calendarCardsContainer.value) {
                            _context2.next = 2;
                            break;
                          }

                          return _context2.abrupt("return");

                        case 2:
                          _context2.next = 4;
                          return nextTick();

                        case 4:
                          if (!product) {
                            _context2.next = 16;
                            break;
                          }

                          // find an event group with still ongoing or upcoming events for a specific ticket
                          targetDate = selectedDate.value; // set target date time to current time to avoid scrolling to already ended time slots

                          if (this.areEqualDates(targetDate, dayjs().toDate())) {
                            targetDate = dayjs().toDate();
                          }

                          targetEventTime = Object.keys(cards.value).find(function (eventTime) {
                            var eventGroup = cards.value[eventTime];
                            var eventEndingAfterCurrentTime = eventGroup.find(function (event) {
                              var eventEnd = dayjs(event.endDateTime);
                              return event.productCategoryId === product.id && eventEnd.isAfter(dayjs(targetDate));
                            });

                            if (eventEndingAfterCurrentTime) {
                              return true;
                            }

                            return false;
                          });

                          if (!targetEventTime) {
                            _context2.next = 13;
                            break;
                          }

                          scrollToGroupingHour(targetEventTime);
                          return _context2.abrupt("return", true);

                        case 13:
                          return _context2.abrupt("return", false);

                        case 14:
                          _context2.next = 17;
                          break;

                        case 16:
                          if (dayjs(selectedDate.value).isSame(dayjs(), "day")) {
                            // find an event group with still ongoing or upcoming events today only
                            _targetEventTime = Object.keys(cards.value).find(function (eventTime) {
                              var eventGroup = cards.value[eventTime];
                              var eventEndingAfterCurrentTime = eventGroup.find(function (event) {
                                var eventEnd = dayjs(event.endDateTime);
                                return eventEnd.isAfter(dayjs());
                              });

                              if (eventEndingAfterCurrentTime) {
                                return true;
                              }

                              return false;
                            });

                            if (_targetEventTime) {
                              scrollToGroupingHour(_targetEventTime);
                            }
                          } else {
                            // go back to the first ticket group if its a future date
                            firstGroupingHour = calendarCardsContainer.value.querySelector("div > p.grouping-hour");

                            if (firstGroupingHour) {
                              firstGroupingHour.scrollIntoView({
                                block: "start",
                                behavior: "auto"
                              });
                            }
                          }

                        case 17:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, this);
                }));
                return _scrollToFirstAvailableEvent.apply(this, arguments);
              };

              scrollToFirstAvailableEvent = function _scrollToFirstAvailab(_x2) {
                return _scrollToFirstAvailableEvent.apply(this, arguments);
              };

              _scrollToTimeSlot = function _scrollToTimeSlot3() {
                _scrollToTimeSlot = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(timeslot) {
                  var targetEventTime;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (calendarCardsContainer.value) {
                            _context.next = 2;
                            break;
                          }

                          return _context.abrupt("return");

                        case 2:
                          _context.next = 4;
                          return nextTick();

                        case 4:
                          targetEventTime = Object.keys(cards.value).find(function (eventTime) {
                            var eventGroup = cards.value[eventTime];
                            var correspondingEvent = eventGroup.find(function (event) {
                              var eventStart = dayjs(event.startDateTime);
                              return eventStart.isSame(dayjs(timeslot));
                            });

                            if (correspondingEvent) {
                              return true;
                            }

                            return false;
                          });

                          if (targetEventTime) {
                            scrollToGroupingHour(targetEventTime);
                          }

                        case 6:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));
                return _scrollToTimeSlot.apply(this, arguments);
              };

              scrollToTimeSlot = function _scrollToTimeSlot2(_x) {
                return _scrollToTimeSlot.apply(this, arguments);
              };

              scrollToGroupingHour = function _scrollToGroupingHour(time) {
                if (!calendarCardsContainer.value) {
                  return;
                }

                var groupingHour = calendarCardsContainer.value.querySelectorAll("div > p.grouping-hour"); // find element to scroll to

                for (var i = 0; i < groupingHour.length; i++) {
                  var element = groupingHour[i];

                  if (element.innerText === time) {
                    element.scrollIntoView({
                      block: "start",
                      behavior: "smooth"
                    });
                    break;
                  }
                }
              };

              handleTouchStart = function _handleTouchStart(e) {
                didScroll.value = false;
              };

              handleScroll = function _handleScroll(e) {
                didScroll.value = true;
              };

              isDateDisabled = function _isDateDisabled(date) {
                // disable if no dates are available
                var dates = allDates.value;

                if (!dates || !dates.length) {
                  return true;
                }

                var dateJS = dayjs(date); // Disable before today

                if (dateJS.isBefore(dayjs(), "day")) {
                  return true;
                }

                return false;
              };

              openCalendar = function _openCalendar() {
                datepicker.value.focus();
              };

              setSwiperRef = function _setSwiperRef(swp) {
                swiper = swp;
              };

              loading = ref(true); // when first loading we select today

              selectedDate = ref(new Date());
              allDates = ref(null);
              pulledDates = ref(null);
              datepicker = ref("datepicker");
              isFetchingFutureDate = ref(false);
              todayDate = ref(new Date());
              calendarCardsContainer = ref();
              locale = computed(function () {
                var languages = {
                  fr: fr,
                  de: de,
                  en: en,
                  it: it,
                  es: es
                };
                var currentLanguage = AppModule.language;
                var loc = languages[currentLanguage];
                return loc;
              });
              _useI18n = useI18n({}), t = _useI18n.t; // Sets Swiper

              // // 1- get timeslots from remote and store them locally
              // // Get product categories from local db
              // let productCategories: IProductCategory[] | undefined =
              //   await getProductCategoriesByTicketsGroup(props.ticketGroupId);
              // // Fetch all corresponding timeSlots from remote db and store them locally
              // let productCategoriesIds = productCategories?.map((pc) => pc.id) || [];
              // await fetchAllPCsTimeslots(productCategoriesIds);
              loading.value = false; // initiating cards variable with today's timeslots data, and make it reactive
              // let cards = ref(await selectDay(new Date()));

              cards = ref({});
              didScroll = ref(false);
              return _context3.abrupt("return", {
                dayjs: dayjs,
                selectedDate: selectedDate,
                isFetchingFutureDate: isFetchingFutureDate,
                // getCards,
                cards: cards,
                loading: loading,
                datepicker: datepicker,
                openCalendar: openCalendar,
                isDateDisabled: isDateDisabled,
                setSwiperRef: setSwiperRef,
                Calendar: Calendar,
                allDates: allDates,
                pulledDates: pulledDates,
                modules: [Navigation, Virtual, FreeMode],
                locale: locale,
                handleScroll: handleScroll,
                handleTouchStart: handleTouchStart,
                didScroll: didScroll,
                infoIcon: infoIcon,
                t: t,
                todayIcon: todayIcon,
                todayIconBlack: todayIconBlack,
                todayDate: todayDate,
                calendarCardsContainer: calendarCardsContainer,
                scrollToFirstAvailableEvent: scrollToFirstAvailableEvent,
                scrollToTimeSlot: scrollToTimeSlot
              });

            case 24:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      var operationStartTime, operationEndTime, operationDuration;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              operationStartTime = performance.now();
              ticketGroupDates = {};
              _context7.next = 4;
              return _this.loadDates();

            case 4:
              _context7.next = 6;
              return _this.selectFirstDate();

            case 6:
              // meausre performance
              operationEndTime = performance.now();
              operationDuration = operationEndTime - operationStartTime;
              recordOperationDuration("CalendarCards", operationDuration);

              _this.emitter.emit("calendarCardsMounted"); // Make sure that whenever the ticketGroupId is changed, we re-render the view.
              // This makes sure that we are able to switch between CalendarGrids, otherwise,
              // the old calendar grid will remain available.
              // Reference  L3-3059


              watch(function () {
                return _this.ticketGroupId;
              }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var _operationStartTime, _operationEndTime, _operationDuration;

                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!_this.ticketGroupId) {
                          _context4.next = 9;
                          break;
                        }

                        _operationStartTime = performance.now(); // When user moves to another ticketGroup, he shouldn't see the selected day of the previous ticketGroup in the datePicker
                        // Lets reload dates

                        _context4.next = 4;
                        return _this.loadDates();

                      case 4:
                        _context4.next = 6;
                        return _this.selectFirstDate();

                      case 6:
                        // meausre performance
                        _operationEndTime = performance.now();
                        _operationDuration = _operationEndTime - _operationStartTime;
                        recordOperationDuration("CalendarCards", _operationDuration);

                      case 9:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              }))); // Wheneever the POS config is changed or selected again, we reset the cache cause we load only 1 day for now.

              watch(selectedConfig, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        if (!selectedConfig.value) {
                          _context5.next = 6;
                          break;
                        }

                        ticketGroupDates = {};
                        _context5.next = 4;
                        return _this.loadDates();

                      case 4:
                        _context5.next = 6;
                        return _this.selectFirstDate();

                      case 6:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }))); // listen for emitted event by the products table (Products.vue)

              _this.emitter.on("scrollToRecurringTicket", /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(data) {
                  var dayAlreadyLoaded;
                  return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          // close the modal that emitted this event
                          ModalModule.setStatus(ModalStatus.Hidden);
                          dayAlreadyLoaded = _this.allDates.find(function (d) {
                            return _this.areEqualDates(d, data.date);
                          });

                          if (!dayAlreadyLoaded) {
                            _context6.next = 7;
                            break;
                          }

                          _context6.next = 5;
                          return _this.getCards(data.date);

                        case 5:
                          _context6.next = 9;
                          break;

                        case 7:
                          _context6.next = 9;
                          return _this.selectCustomDate(data.date);

                        case 9:
                          _context6.next = 11;
                          return _this.scrollToFirstAvailableEvent(data.product);

                        case 11:
                          if (!_context6.sent) {
                            _context6.next = 15;
                            break;
                          }

                          NotificationService.showCustomInfoWithTitle(_this.t("select.ticket"), "Info");
                          _context6.next = 16;
                          break;

                        case 15:
                          NotificationService.showCustomMessage(_this.t("calendar.no-timeslots"), "warning");

                        case 16:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6);
                }));

                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 13:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  },
  beforeUnmount: function beforeUnmount() {
    swiper = null; // turn off emitter listener to avoid multiple firings

    this.emitter.off("scrollToRecurringTicket");
  },
  methods: {
    loadDates: function loadDates() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var dates, datesCached, d, availableDates;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                // Get all dates that have availabilities
                // Make sure that Cache has an entry for current Ticket group
                if (!ticketGroupDates[_this2.ticketGroupId]) {
                  ticketGroupDates[_this2.ticketGroupId] = [];
                }

                dates = ticketGroupDates[_this2.ticketGroupId];
                datesCached = !!dates.length; // make sure that at least today is loaded

                if (!CommonModule.ticketGroupLoadedDates[_this2.ticketGroupId]) {
                  d = new Date(); // UTC set to midnight

                  CommonModule.addTicketGroupLoadedDates({
                    ticketGroupId: _this2.ticketGroupId,
                    date: new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
                  });
                }

                if (!datesCached) {
                  // Compute dates in case cache doesn't already have cached dates
                  dates = CommonModule.ticketGroupLoadedDates[_this2.ticketGroupId] || [];
                  ticketGroupDates[_this2.ticketGroupId] = dates;
                }

                availableDates = _toConsumableArray(dates); // if dates are cached, upper calendar doesn't get displayed, so let's add a small
                // delay for that

                if (!datesCached) {
                  _context8.next = 9;
                  break;
                }

                _context8.next = 9;
                return nextTick();

              case 9:
                // TODO @Riyadh: Check logic
                _this2.allDates = availableDates;
                _this2.pulledDates = _toConsumableArray(availableDates);

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },

    /**
     * Returns an object of grouped cards by hour
     * @param a date
     */
    selectDay: function selectDay(day) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var date, cards, dayTimeSlots, groupedTimeslots, _loop, key;

        return regeneratorRuntime.wrap(function _callee9$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                // Lets use a copy of the parameter Date object to avoid changing the original value
                // let date = new Date(day.getTime());
                date = dayjs(day).toDate();
                cards = {}; // One rule for dates:
                // 2022-04-21T00:00:00.000Z is actually the last moment of the day, not the first moment
                // Why? If you add one second to it you will get 2022-04-22T00:00:01.000Z
                // 1- Calendar view: give me all the timeslots of day x from database.
                // (startDateTime >= midNight(day x) && startDateTime < TomorrowMidnight(day x) )
                // Add now time of the user to the date object so that we only show slots related to now (check getTimeslotsByDate() for more)
                // TODO Riyadh: Check
                // N.B: for FlipLab we show all slots of today even the ended ones

                date = new Date(date.toDateString() + " " + new Date().toTimeString());
                _context10.next = 5;
                return getTimeslotsByDate(date, _this3.ticketGroupId);

              case 5:
                dayTimeSlots = _context10.sent;
                // 2- group timeslots by hour
                groupedTimeslots = _this3.groupTimeslotsByHour(dayTimeSlots) || {}; // 3- convert each ITimeSlots into ICardData

                _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop(key) {
                  var i, tempCards, _tempCards;

                  return regeneratorRuntime.wrap(function _loop$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          i = 0;

                        case 1:
                          if (!(i < groupedTimeslots[key].length)) {
                            _context9.next = 16;
                            break;
                          }

                          if (cards[key]) {
                            _context9.next = 9;
                            break;
                          }

                          _context9.next = 5;
                          return _this3.getCardData(groupedTimeslots[key][i]);

                        case 5:
                          tempCards = _context9.sent;
                          cards[key] = tempCards.flat();
                          _context9.next = 13;
                          break;

                        case 9:
                          _context9.next = 11;
                          return _this3.getCardData(groupedTimeslots[key][i]);

                        case 11:
                          _tempCards = _context9.sent;

                          _tempCards.flat().forEach(function (element) {
                            cards[key].push(element);
                          });

                        case 13:
                          i++;
                          _context9.next = 1;
                          break;

                        case 16:
                          // Done filling in cards[key]
                          // Lets now sort the cards in cards[key] by their category name
                          if (cards[key]) {
                            cards[key].sort(function (a, b) {
                              if (Number(a.sortOrderPos) > Number(b.sortOrderPos)) {
                                return 1;
                              } else if (Number(a.sortOrderPos) < Number(b.sortOrderPos)) {
                                return -1;
                              } // a must be equal to b


                              return 0;
                            });
                          }

                        case 17:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _loop);
                });
                _context10.t0 = regeneratorRuntime.keys(groupedTimeslots);

              case 9:
                if ((_context10.t1 = _context10.t0()).done) {
                  _context10.next = 14;
                  break;
                }

                key = _context10.t1.value;
                return _context10.delegateYield(_loop(key), "t2", 12);

              case 12:
                _context10.next = 9;
                break;

              case 14:
                return _context10.abrupt("return", cards);

              case 15:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee9);
      }))();
    },

    /**
     * Takes an array of timeslots and return an object of timeslots grouped by hour
     */
    groupTimeslotsByHour: function groupTimeslotsByHour(timeslots) {
      var _POSConfigModule$sele, _POSConfigModule$sele2;

      if (!timeslots) {
        return;
      } // 1- sort timeslots based on their startDateTime


      timeslots.sort(function (t1, t2) {
        var time1 = dayjs(t1.startDateTime).toDate().toISOString();
        var time2 = dayjs(t2.startDateTime).toDate().toISOString();

        if (time1 < time2) {
          return -1;
        }

        if (time1 > time2) {
          return 1;
        } // times must be equal


        return 0;
      }); // 2- create an empty array of Record<string, ITimeSlot[]>

      var groupedTimeslots = {}; // We now need to to put timeslots in object that has properties as dateTime and assigned arrays of timeslots
      // For a better maintenance:
      // - lets build an intermediate grouped array with empty timeslots but with periods
      // - fill intermediateGroupedTimeslots object with properties only (the value is an empty array of timeslots)
      // - assign each property of intermediateGroupedTimeslots with an array of timeslots that are contained within
      // - remove properties that still have empty array as a value from the object intermediateGroupedTimeslots
      // - fill in the final object groupedTimeslots2
      // lets build the grouped array with empty timeslots but with periods

      var intermediateGroupedTimeslots = {};
      var groupedTimeslots2 = {};
      var startTime = dayjs(timeslots[0].startDateTime);
      var endTime = dayjs(timeslots[timeslots.length - 1].endDateTime);
      var intermediateTime = startTime.set("minute", 0);
      var timeGrid = POSConfigModule.selectedGrid && (_POSConfigModule$sele = POSConfigModule.selectedGrid) !== null && _POSConfigModule$sele !== void 0 && _POSConfigModule$sele.timeGrid ? (_POSConfigModule$sele2 = POSConfigModule.selectedGrid) === null || _POSConfigModule$sele2 === void 0 ? void 0 : _POSConfigModule$sele2.timeGrid : 60; // 1- lets fill intermediateGroupedTimeslots object with properties only (the value is an empty array of timeslots)

      do {
        // lets create a grouped period with empty array of timeslots
        var hour = intermediateTime.toString();
        intermediateGroupedTimeslots[hour] = [];
        intermediateTime = intermediateTime.add(timeGrid, "minute");
      } while (intermediateTime.isBefore(endTime)); // 2- lets assign each property of intermediateGroupedTimeslots with an array of timeslots that are contained within


      for (var i = 0; i < timeslots.length; i++) {
        for (var j = 0; j < Object.keys(intermediateGroupedTimeslots).length; j++) {
          var currentGroupedDateTime = dayjs(Object.keys(intermediateGroupedTimeslots)[j]);
          var slotDayJs = dayjs(timeslots[i].startDateTime);

          if (j + 1 < Object.keys(intermediateGroupedTimeslots).length) {
            // So there is a next groupedDateTime
            var nextGroupedDateTime = dayjs(Object.keys(intermediateGroupedTimeslots)[j + 1 >= Object.keys(intermediateGroupedTimeslots).length ? j : j + 1]); // If the slot is within currentGroupedDateTime and before nextGroupedDateTime then we add it to the array

            if (slotDayJs.isBefore(nextGroupedDateTime) && (slotDayJs.isAfter(currentGroupedDateTime) || slotDayJs.isSame(currentGroupedDateTime))) {
              intermediateGroupedTimeslots[Object.keys(intermediateGroupedTimeslots)[j]].push(timeslots[i]);
            } else {// console.log("---------- not really");
            }
          } else {
            // so there is no next groupedDateTime, this is the last groupedDateTime
            if (slotDayJs.isAfter(currentGroupedDateTime) || slotDayJs.isSame(currentGroupedDateTime)) {
              intermediateGroupedTimeslots[Object.keys(intermediateGroupedTimeslots)[j]].push(timeslots[i]);
            } else {// If we're in this block it means we have a timeslot within the day but isn't within ant of intermediateGroupedTimeslots
              // which should be wrong except in one case where a timeslot actually start in one day and end in another day
              // whhich is Nuit des Musée 18860 and group:15161 case only
            }
          }
        }
      } // 3- lets remove properties that still have empty array as a value from the object intermediateGroupedTimeslots


      for (var _j = 0; _j < Object.keys(intermediateGroupedTimeslots).length; _j++) {
        if (!intermediateGroupedTimeslots[Object.keys(intermediateGroupedTimeslots)[_j]].length) {
          delete intermediateGroupedTimeslots[Object.keys(intermediateGroupedTimeslots)[_j]];
        }
      } // 4- lets fill in the final object groupedTimeslots2


      for (var _j2 = 0; _j2 < Object.keys(intermediateGroupedTimeslots).length; _j2++) {
        // Now we start building the final object groupedTimeslots2 but with with formatted dates as properties' names
        var newPropertyName = dayjs(Object.keys(intermediateGroupedTimeslots)[_j2]).format(getGroupDayJsTimeFormat());

        if (UserModule.getUserGroupId === 15161 || POSConfigModule.isEdeis) {
          // This is special for groups with a timeslot that last for more than one day
          // groupedTimeslots2[newPropertyName] might already have items, from day1 so we need
          // if intermediateGroupedTimeslots are from the same day then we push them to groupedTimeslots2[newPropertyName]
          var currentGroupedDateTime2 = dayjs(Object.keys(intermediateGroupedTimeslots)[_j2]);

          if (intermediateGroupedTimeslots[Object.keys(intermediateGroupedTimeslots)[_j2]][0]) {
            var firstSlotDayJs = dayjs(intermediateGroupedTimeslots[Object.keys(intermediateGroupedTimeslots)[_j2]][0].startDateTime);

            if (firstSlotDayJs.isSame(currentGroupedDateTime2, "day")) {
              groupedTimeslots2[newPropertyName] = cloneDeep(intermediateGroupedTimeslots[Object.keys(intermediateGroupedTimeslots)[_j2]]);
            } else {// We don't do anything because we are in next days, why?  because in this special case we're pulling timeslots from next days to cover multi-days slots
            }
          }
        } else {
          groupedTimeslots2[newPropertyName] = cloneDeep(intermediateGroupedTimeslots[Object.keys(intermediateGroupedTimeslots)[_j2]]);
        }
      }

      return groupedTimeslots2; // for (let i = 0; i < timeslots.length; i++) {
      //   let hour: string = dayjs(timeslots[i].startDateTime)
      //     .set("minute", 0)
      //     .format(getGroupDayJsTimeFormat());
      //   // lets check if this record has timeslots of this hour
      //   if (!groupedTimeslots || groupedTimeslots[hour]) {
      //     // so this hour has a record already, lets add the currect timeslot to this record
      //     groupedTimeslots[hour].push(timeslots[i]);
      //   } else {
      //     // so the record does not have timeslots of this hour, lets add it
      //     groupedTimeslots[hour] = [timeslots[i]];
      //   }
      // }
      // console.log("groupedTimeslots");
      // console.log(groupedTimeslots);
      // console.log("length");
      // console.log(Object.values(groupedTimeslots).flat().length);
      // return groupedTimeslots;
    },
    getCards: function getCards(day) {
      var _arguments = arguments,
          _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var options, _options$refresh, refresh;

        return regeneratorRuntime.wrap(function _callee10$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                options = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {};
                _options$refresh = options.refresh, refresh = _options$refresh === void 0 ? false : _options$refresh;

                if (!refresh) {
                  _context11.next = 15;
                  break;
                }

                _context11.prev = 3;
                AppModule.setIsBackgroundLoading(true);
                _context11.next = 7;
                return _this4.pullAndStoreTimeslotsByDate(day.toISOString(), _this4.ticketGroupId);

              case 7:
                _context11.next = 12;
                break;

              case 9:
                _context11.prev = 9;
                _context11.t0 = _context11["catch"](3);
                LogService.info("Availability: Error pulling timeslots for date", {
                  error: _context11.t0,
                  ticketGroupId: _this4.ticketGroupId,
                  date: day.toISOString()
                });

              case 12:
                _context11.prev = 12;
                AppModule.setIsBackgroundLoading(false);
                return _context11.finish(12);

              case 15:
                _context11.next = 17;
                return _this4.selectDay(day);

              case 17:
                _this4.cards = _context11.sent;
                _this4.selectedDate = new Date(day.getTime());

                if (POSConfigModule.isFlipLab) {
                  _this4.scrollToFirstAvailableEvent();
                }

              case 20:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee10, null, [[3, 9, 12, 15]]);
      }))();
    },

    /**
     * Takes an object of type ITimeSlot and returns an object of type ICardData
     */
    getCardData: function getCardData(timeslot) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var isSeparatedButtons, product, currentLanguage, minPrice;
        return regeneratorRuntime.wrap(function _callee11$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                isSeparatedButtons = POSConfigModule.isSeperatedButtons;
                _context12.next = 3;
                return getProductCategoryById(timeslot.categoryId);

              case 3:
                product = _context12.sent;
                currentLanguage = getLanguage();

                if (isSeparatedButtons) {
                  _context12.next = 10;
                  break;
                }

                // IF it is seating plan product then we take the minPrice of all sub-categories
                // else we take minPricce of prices
                minPrice = product && product.type === PCTypes[PCTypes.Seated] && product.subCategories && product.subCategories.length ? product.subCategories.map(function (sbpc) {
                  return sbpc.prices;
                }).flat().sort(function (p1, p2) {
                  return Number(p1) - Number(p2);
                })[0].value : product === null || product === void 0 ? void 0 : product.prices.sort(function (p1, p2) {
                  return Number(p1) - Number(p2);
                })[0].value;
                return _context12.abrupt("return", [{
                  productCategoryId: product === null || product === void 0 ? void 0 : product.id,
                  productName: (product === null || product === void 0 ? void 0 : product.product.nameLocale[currentLanguage]) || (product === null || product === void 0 ? void 0 : product.product.name),
                  categoryName: (product === null || product === void 0 ? void 0 : product.nameLocale[currentLanguage]) || (product === null || product === void 0 ? void 0 : product.name),
                  dbAvailability: timeslot.availability,
                  startDateTime: timeslot.startDateTime,
                  endDateTime: timeslot.endDateTime,
                  currency: product === null || product === void 0 ? void 0 : product.product.currency,
                  pictureUrl: product === null || product === void 0 ? void 0 : product.product.pictureUrl,
                  price: minPrice,
                  prices: product === null || product === void 0 ? void 0 : product.prices,
                  productCategory_ID: product === null || product === void 0 ? void 0 : product._id,
                  timeslot_ID: timeslot._id,
                  type: String(product === null || product === void 0 ? void 0 : product.type),
                  saleStartType: product === null || product === void 0 ? void 0 : product.saleStartType,
                  saleStart: product === null || product === void 0 ? void 0 : product.saleStart,
                  saleEndType: product === null || product === void 0 ? void 0 : product.saleEndType,
                  saleEnd: product === null || product === void 0 ? void 0 : product.saleEnd,
                  salesEndDurationMinutes: product === null || product === void 0 ? void 0 : product.salesEndDurationMinutes,
                  salesStartDurationDays: product === null || product === void 0 ? void 0 : product.salesStartDurationDays,
                  sortOrderPos: Number(product === null || product === void 0 ? void 0 : product.sortOrderPos),
                  stockIds: (product === null || product === void 0 ? void 0 : product.stockIds) || [],
                  booked: timeslot.booked,
                  // Seating Plan logic
                  eventKey: product && (product.type === PCTypes[PCTypes.SeatedSub] || product.type === PCTypes[PCTypes.Seated]) && !product.isReccuringSeating ? String(product.resourceEventKey) : timeslot.eventKey,
                  isReccuringSeating: product && (product.type === PCTypes[PCTypes.SeatedSub] || product.type === PCTypes[PCTypes.Seated]) ? Number(product.isReccuringSeating) : null,
                  seatingParentPSCId: product && product.type === PCTypes[PCTypes.SeatedSub] ? product.seatingParentPSCId : null,
                  seatingParentCategoryName: product && product.type === PCTypes[PCTypes.SeatedSub] ? product.seatingParentCategoryName : "",
                  seatedSubs: product && product.subCategories ? product.subCategories : []
                }]);

              case 10:
                return _context12.abrupt("return", product ? _this5.splitPCs(product, timeslot) : []);

              case 11:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee11);
      }))();
    },
    splitPCs: function splitPCs(pc, timeslot) {
      // This function takes a PC object and returns an array of PCs each with only one price. PCs are basically a copy of each other except the price
      var CDs = [];
      var currentLanguage = getLanguage();
      var pricesCount = pc.prices.length;

      for (var j = 0; j < pricesCount; j++) {
        // if this is retail PC and has more than one price and this price has the default price then skip it, because we need prices with not-default-retail
        if (pricesCount > 1 && pc.type === PCTypes[PCTypes.Retail] && pc.prices[j].retail[0].type === RetailOptionType.Default_Retail_Option) {
          continue;
        }

        var clonedPC = _cloneDeep(pc);

        clonedPC.prices = [];
        clonedPC.prices = [pc.prices[j]];
        var cd = {
          productCategoryId: clonedPC.id,
          productName: clonedPC.product.nameLocale[currentLanguage] || clonedPC.product.name,
          categoryName: clonedPC.nameLocale[currentLanguage] || clonedPC.name,
          dbAvailability: timeslot.availability,
          startDateTime: timeslot.startDateTime,
          endDateTime: timeslot.endDateTime,
          currency: clonedPC.product.currency,
          pictureUrl: clonedPC.product.pictureUrl,
          price: clonedPC.prices.sort(function (p1, p2) {
            return Number(p1) - Number(p2);
          })[0].value,
          prices: clonedPC.prices,
          productCategory_ID: clonedPC._id,
          timeslot_ID: timeslot._id,
          type: String(clonedPC.type),
          saleEnd: clonedPC.saleEnd,
          saleEndType: clonedPC.saleEndType,
          saleStart: clonedPC.saleStart,
          saleStartType: clonedPC.saleStartType,
          salesEndDurationMinutes: clonedPC.salesEndDurationMinutes,
          salesStartDurationDays: clonedPC.salesStartDurationDays,
          sortOrderPos: Number(clonedPC.sortOrderPos),
          stockIds: clonedPC.stockIds || [],
          booked: timeslot.booked,
          // Seating Plan logic
          eventKey: clonedPC && clonedPC.type === PCTypes[PCTypes.SeatedSub] && !clonedPC.isParentReccuringSeating ? clonedPC.seatingParentResourceEventKey : timeslot.eventKey,
          isReccuringSeating: clonedPC && clonedPC.type === PCTypes[PCTypes.SeatedSub] ? clonedPC.isParentReccuringSeating : null,
          seatingParentPSCId: clonedPC && clonedPC.type === PCTypes[PCTypes.SeatedSub] ? clonedPC.seatingParentPSCId : null,
          seatingParentCategoryName: clonedPC && clonedPC.type === PCTypes[PCTypes.SeatedSub] ? clonedPC.seatingParentCategoryName : ""
        };
        CDs.push(cd);
      }

      return CDs;
    },
    areEqualDates: function areEqualDates(date1, date2) {
      if (!date1 || !date2) {
        return false;
      }

      return date1.getDate() === date2.getDate() && date1.getMonth() === date2.getMonth() && date1.getFullYear() === date2.getFullYear();
    },
    selectCustomDate: function selectCustomDate(date) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var index;
        return regeneratorRuntime.wrap(function _callee12$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _this6.isFetchingFutureDate = true;
                _context13.prev = 1;
                _context13.next = 4;
                return _this6.pullAndStoreTimeslotsByDate(date.toISOString(), _this6.ticketGroupId);

              case 4:
                // Retrieve the swiper index where that date should be inserted
                index = sortedIndex(_this6.allDates, date); // Check if the date already exists in the horizontal calendar

                if (!dayjs(_this6.allDates[index]).isSame(dayjs(date), "day")) {
                  // Add the date in the right position in the array of dates
                  ticketGroupDates[_this6.ticketGroupId].splice(index, 0, date);
                }

                _context13.next = 8;
                return _this6.loadDates();

              case 8:
                _context13.next = 10;
                return _this6.getCards(date);

              case 10:
                _this6.isFetchingFutureDate = false; //await Timeout.set(100);
                // Slide to that date;

                swiper.slideTo(index);
                CommonModule.addTicketGroupLoadedDates({
                  ticketGroupId: _this6.ticketGroupId,
                  date: date
                });
                _context13.next = 21;
                break;

              case 15:
                _context13.prev = 15;
                _context13.t0 = _context13["catch"](1);
                _this6.isFetchingFutureDate = false; // if there's an issue fetching the timeslots or the app is offline let's re-select today's day and show a warning message

                _this6.getCards(_this6.allDates[0]);

                NotificationService.showCustomMessage(_this6.t("error.load-timeslots"), "warning");
                throw _context13.t0;

              case 21:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee12, null, [[1, 15]]);
      }))();
    },
    getFutureDates: function getFutureDates(dates) {
      var _this7 = this;

      var d = (dates === null || dates === void 0 ? void 0 : dates.filter(function (d) {
        return !_this7.areEqualDates(d, _this7.todayDate);
      })) || [];
      return d; // const noneDuplicatedDates = [... new Set(d)];
      // console.log("noneDuplicatedDates");
      // console.log(noneDuplicatedDates);
      // return noneDuplicatedDates;
    },
    selectFirstDate: function selectFirstDate() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var b, today;
        return regeneratorRuntime.wrap(function _callee13$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (!_this8.allDates.length) {
                  _context14.next = 6;
                  break;
                }

                b = _this8.allDates[0];
                _context14.next = 4;
                return _this8.getCards(b, {
                  refresh: true
                });

              case 4:
                _context14.next = 10;
                break;

              case 6:
                today = new Date(dayjs().toDate());

                _this8.allDates.unshift(today);

                _context14.next = 10;
                return _this8.getCards(today, {
                  refresh: true
                });

              case 10:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee13);
      }))();
    },
    pullAndStoreTimeslotsByDate: function pullAndStoreTimeslotsByDate(date) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var productCategories, productCategoriesIds, _iterator, _step, productCategory, categoryId, _iterator2, _step2, price, _iterator3, _step3, addon, addonPC;

        return regeneratorRuntime.wrap(function _callee14$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (!(!_this9.ticketGroupId || !date)) {
                  _context15.next = 2;
                  break;
                }

                return _context15.abrupt("return");

              case 2:
                _context15.prev = 2;
                _context15.next = 5;
                return getProductCategoriesByTicketsGroup(_this9.ticketGroupId);

              case 5:
                _context15.t0 = _context15.sent;

                if (_context15.t0) {
                  _context15.next = 8;
                  break;
                }

                _context15.t0 = [];

              case 8:
                productCategories = _context15.t0;
                productCategoriesIds = [];
                _iterator = _createForOfIteratorHelper(productCategories);
                _context15.prev = 11;

                _iterator.s();

              case 13:
                if ((_step = _iterator.n()).done) {
                  _context15.next = 53;
                  break;
                }

                productCategory = _step.value;
                // get each PC id depending on its types to load its timeslots
                categoryId = productCategory.type === PCTypes[PCTypes.SeatedSub] && productCategory.seatingParentPSCId ? productCategory.seatingParentPSCId : productCategory.id;
                productCategoriesIds.push(categoryId); // find PC addons and load their timeslots as well if not included already

                _iterator2 = _createForOfIteratorHelper(productCategory.prices);
                _context15.prev = 18;

                _iterator2.s();

              case 20:
                if ((_step2 = _iterator2.n()).done) {
                  _context15.next = 43;
                  break;
                }

                price = _step2.value;
                _iterator3 = _createForOfIteratorHelper(price.addons);
                _context15.prev = 23;

                _iterator3.s();

              case 25:
                if ((_step3 = _iterator3.n()).done) {
                  _context15.next = 33;
                  break;
                }

                addon = _step3.value;
                _context15.next = 29;
                return getProductCategoryByPrice(addon.priceId);

              case 29:
                addonPC = _context15.sent;

                if (addonPC && !productCategoriesIds.includes(addonPC.id)) {
                  productCategoriesIds.push(addonPC.id);
                }

              case 31:
                _context15.next = 25;
                break;

              case 33:
                _context15.next = 38;
                break;

              case 35:
                _context15.prev = 35;
                _context15.t1 = _context15["catch"](23);

                _iterator3.e(_context15.t1);

              case 38:
                _context15.prev = 38;

                _iterator3.f();

                return _context15.finish(38);

              case 41:
                _context15.next = 20;
                break;

              case 43:
                _context15.next = 48;
                break;

              case 45:
                _context15.prev = 45;
                _context15.t2 = _context15["catch"](18);

                _iterator2.e(_context15.t2);

              case 48:
                _context15.prev = 48;

                _iterator2.f();

                return _context15.finish(48);

              case 51:
                _context15.next = 13;
                break;

              case 53:
                _context15.next = 58;
                break;

              case 55:
                _context15.prev = 55;
                _context15.t3 = _context15["catch"](11);

                _iterator.e(_context15.t3);

              case 58:
                _context15.prev = 58;

                _iterator.f();

                return _context15.finish(58);

              case 61:
                _context15.next = 63;
                return fetchAllPCsTimeslotsByDate(productCategoriesIds, date);

              case 63:
                _context15.next = 68;
                break;

              case 65:
                _context15.prev = 65;
                _context15.t4 = _context15["catch"](2);
                LogService.info("Availability: Error pulling timeslots for date ".concat(date, " and ticket group ").concat(_this9.ticketGroupId), {
                  params: {
                    date: date,
                    ticketGroupId: _this9.ticketGroupId
                  },
                  error: _context15.t4
                });

              case 68:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee14, null, [[2, 65], [11, 55, 58, 61], [18, 45, 48, 51], [23, 35, 38, 41]]);
      }))();
    }
  }
});